import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconDownload_24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M12.002 3.75V15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50195 11.25L12.002 15.75L16.502 11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.252 15.75V17.25C23.252 18.0456 22.9359 18.8087 22.3733 19.3713C21.8107 19.9339 21.0476 20.25 20.252 20.25H3.75195C2.9563 20.25 2.19324 19.9339 1.63063 19.3713C1.06802 18.8087 0.751953 18.0456 0.751953 17.25V15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconDownload_24.displayName = 'IconDownload_24';
